import { Box } from '@mui/material'
import * as React from 'react'
import StudyInfo from './StudyInfo'
import StudyPageToggle from '../StudyPageToggle'
import PageSection from '../../../Constants&Theme/PageSection'
import PhaseList from '../ConfigurePhase/PhaseList'

function Configure() {
  return (
    <Box
      sx={{
        maxWidth: 'xl',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection
        title={'Configure Study'}
        leftDecorator={<StudyPageToggle />}
      >
        <StudyInfo />
        <PhaseList />
      </PageSection>
    </Box>
  )
}

export default Configure
